import { styled } from "../../../../styles";

export const ModalContainer = styled("div", {
  height: "100%",
  width: "fit-content",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  padding: "24px 26px",

  "@sm": {
    width: "100%",
    justifyContent: "center",
    padding: "0",
  },
});

export const Title = styled("p", {
  color: "$black",
  fontFamily: "$openSans",
  fontSize: "16px",
  lineHeight: "22px",
  fontWeight: "500",

  marginBottom: "16px",
  paddingLeft: "16px",
});

export const SubmitContainer = styled("div", {
  height: "70px",
  display: "flex",
  padding: "26px 12px 0px 10px",
  alignItems: "center",
});
